const environment = {
  local: false,
  localIp: '',
  production: true,
  apiHost: 'https://api2.students.howdengroup.com',
  appHost: 'https://my.endsleigh.co.uk/',
  apiPath: 'api',
  apiVersion: 'v1',
  defaultTitle: 'Howden for Students',
  defaultDescription: 'The Howden for Students Website and Mobile App',
  facebook: {
    appId: '907211114594256',
  },
  strapi: {
    domain: 'cms.students.howdengroup.com',
    token:
      '866e7835c01147c53c73a8058e6b0936e36dcb4758b3eb9157db786ba2f6b506417cc3a33705866279921547a9e69f7ae769138e2e348d923373aaf6373911c1f3448f8b32d947d82182b232b176c69125d31c80014f96abeadbe05984f5f444055a19e8513d4ea26f2054e331c38b87d638c2f5757fe647446371cc452c1666',
    url: 'https://cms.students.howdengroup.com/api',
  },
  google: {
    client_id:
      '436329716348-2032nrv0dgu6n8639kst2lp68030p896.apps.googleusercontent.com',
    project_id: 'howden-for-students-435313',
    auth_uri: 'https://accounts.google.com/o/oauth2/auth',
    token_uri: 'https://oauth2.googleapis.com/token',
    auth_provider_x509_cert_url: 'https://www.googleapis.com/oauth2/v1/certs',
    client_secret: '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',
    javascript_origins: [
      'https://my.endsleigh.co.uk',
      'https://students.howdengroup.com',
    ],
    recaptcha_site_key: '6Le-lgMmAAAAAN6DuiIsdO0yuwoIKfPScKF5l22q',
  },
  app: {
    slug: 'project-x',
    scheme: ' myapp://',
    project: 'bluefusesystems',
  },
  apple: {
    client_id: 'com.howdengroup.students',
    scope: 'name email',
    redirect_uri: 'https://students.howdengroup.com',
  },
  postcodeUrl: 'https://api.postcodes.io/postcodes/',
  sentry_dsn:
    'https://4ad0d9f205e36f2ab66a7d13ce9decde@o4504293988368384.ingest.sentry.io/4505748283195392',
  name: 'production',
};
export default environment;
